module.exports = __webpack_public_path__ + "img/vertical_4_1_2.c2db5c80.png";